var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.295 19h22.41V1.3H1.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.288 2.485 13.268 11.7c-.434.5-1.142.498-1.575-.003L1.526 2.235M9.2 9.387 2 17.682M23.038 17.716l-7.003-8.1"
  }))));
};
export { SvgEnvelope as ReactComponent };
export default __webpack_public_path__ + "images/envelope.svg";